const ENDPOINTS = {
  ID: {
    REFRESH_TOKEN_URL: "api/users/refresh-token",
  },
  PLATFORM: {
    LOGIN_URL: "/api/v2/Login",
    REQUEST_RESET_PASSWORD: "/api/v2/User/SendPasswordReset/",
    RESET_PASSWORD: "/api/v2/User/ResetPassword",
    GET_USER_INFO: "/api/v2/Login/GetUser",
    SET_UNIT_TYPE: "api/v2/Precision/User/SetUnitType/",
    GET_CUSTOMER_EMAIL: "/api/v2/Registration/GetRegistration/",
    GET_CUSTOMERS: "/api/v2/Precision/User/GetCustomers",
    GET_CUSTOMER_PROFILE: "/api/v2/Precision/User/GetCustomerProfile/",
    EDIT_CUSTOMER_PROFILE: "/api/v2/Precision/User/UpdateProfile/",
    GET_COSTUMER_BIOMARKERS: "/api/v2/Precision/User/GetBiomarkers/",
    DELETE_COSTUMER_BIOMARKERS: "/api/v2/Precision/User/DeleteBiomarker/",
    UPDATE_COSTUMER_BIOMARKERS: "/api/v2/Precision/User/UpdateBiomarker/",
    UPDATE_COSTUMER_BIOMARKERS_MULTIPLE:
      "/api/v2/Precision/User/UpdateInbodyBiomarkers",
    // Batch per-biomarker update: array of { biomarkerId, userId, date, +
    // newValue | qvalue | range_* }. Accepts numeric, qualitative, and range
    // values (userId travels in each item, so no path param).
    UPDATE_COSTUMER_BIOMARKERS_BATCH:
      "/api/v2/Precision/User/UpdateBiomarkers",
    UPLOAD_COSTUMER_BIOMARKERS: "api/v2/Precision/Biomarkers/Upload/",
    UPLOAD_COSTUMER_BIOMARKERS_AGENT: "api/v2/Precision/Biomarkers/Extractor",
    UPLOAD_COSTUMER_BIOMARKERS_STATUS_AGENT:
      "/api/v2/Precision/Biomarkers/extractor/status/",
    // Keragon trigger proxy (agent API, Bearer): forwards { url, body } to the
    // workflow's Keragon signal URL server-side — Keragon blocks browser CORS.
    KERAGON_WEBHOOK_TRIGGER: "/api/v2/Webhook/Trigger",
    // Keragon lab import poll (agent API, anonymous): ?email&first_name&last_name
    KERAGON_RESULT_STATUS: "/api/v2/Precision/Biomarkers/KeragonResult/status",
    UPDATE_COSTUMER_SELECTED_METRICS:
      "/api/v2/Precision/report/SetSelectedMetrics",
    UPDATE_COSTUMER_SELECTED_BIOMARKERS:
      "/api/v2/Precision/report/SetSelectedBiomarkers",
    GET_BIOMARKERS_TEXT: "/api/v2/Precision/User/GetAllBiomarkers",
    INVITE_USER: "api/v2/registration/register",
    DELETE_INVITED_USER: "api/v2/registration/deleteInvitation",
    RESEND_INVITATION: "api/v2/registration/resendInvitation",
    REGISTER_USER: "/api/v2/Registration/Activate",
    SUBMIT_BIOMETRIC_QUESTIONNAIRE: "/api/v2/Registration/UpdateProfile",
    SUBMIT_BIOMETRIC_QUESTIONNAIRE_TO_NUT_FAILED:
      "/api/v2/Registration/PostFail",
    // GET_PLATFORM_DATA: "/api/v2/Precision/report/GetReportRC/",
    GET_PLATFORM_DATA: "/api/v2/Precision/report/GetReportv2/",
    GET_REPORT_DATA: "/api/v2/Report/GetReportJson",
    GET_REPORT_DATA_PLATFORM: "/api/v2/Report/GetReportJsonP",
    GET_COUNTRIES: "/GetCountries",
    IMPORT_COSTUMER_KERAGON: "/api/v2/keragon/Create",
    // Keragon EHR sync — company workflows (webhook URLs) managed in Settings.
    KERAGON_ADD_COMPANY_WORKFLOW: "/api/v2/keragon/AddCompanyWorkflow",
    KERAGON_GET_COMPANY_WORKFLOWS: "/api/v2/keragon/GetCompanyWorkflows",
    KERAGON_GET_COMPANY_WORKFLOW: "/api/v2/keragon/GetCompanyWorkflows/",
    KERAGON_DELETE_COMPANY_WORKFLOW: "/api/v2/keragon/DeleteCompanyWorkflow/",
    GET_ALL_SERVICES: "/api/v2/Precision/ServiceBuilder/GetAllServices/",
    GET_SERVICE_BY_ID: "/api/v2/Precision/ServiceBuilder/GetService/",
    GET_LOGIC_BUILDER_SERVICE_BY_ID:
      "/api/v2/Precision/LogicBuilder/GetUserServices",
    LOAD_USER_LOGIC: "/api/v2/Precision/LogicBuilder/GetAll",
    UPDATE_LOGIC: "/api/v2/Precision/LogicBuilder/Update",
    UPDATE_LOGIC_STATUS: "/api/v2/Precision/LogicBuilder/SetEnabled/",
    DELETE_LOGIC: "/api/v2/Precision/LogicBuilder/DeleteLogic/",
    LOAD_SERVICE: "/api/v2/Precision/ServiceBuilder/LoadService/",
    UPDATE_SERVICE: "/api/v2/Precision/ServiceBuilder/Update",
    DELETE_SERVICE: "/api/v2/Precision/ServiceBuilder/DeleteService/",
    UPLOAD_SERVICE_IMAGE: "/api/v2/Precision/ServiceBuilder/Upload/",
    GET_USER_SAVED_SERVICES: "/api/v2/Precision/ServiceBuilder/GetUserServices",
    GET_LOGIC_CATEGORIES: "api/v2/precision/logicbuilder/getcategories",
    UPDATE_CUSTOMER_SERVICE: "/api/v2/Precision/CustomerPrescription/Update",
    GENERATE_LOGIC_SERVICES:
      "/api/v2/Precision/CustomerPrescription/GeneratePrescription/",
    DELETE_USER_PRESCRIPTION: "/api/v2/Precision/CustomerPrescription/Delete",
    GET_NEW_REPORT: "/api/v2/Precision/report/GetPrescriptionReport/",
    GET_CONSULTATION: "/api/v2/Precision/Report/GetConsultation/",
    TOGGLE_SYSTEM: "/api/v2/Precision/Report/ToggleSystem",
    GET_USER_LAB_PANELS: "/api/v2/Precision/LabPanel/GetUserLabPanels",
    GET_PROVIDER_LAB_PANELS: "/api/v2/Precision/LabPanel/GetProviderLabPanels/",
    GET_PROVIDER_BIOMARKERS: "/api/v2/Precision/LabPanel/GetProviderBiomarkers/",
    UPDATE_USER_LAB_PANEL: "/api/v2/Precision/LabPanel/UpdateUserLabPanel",
    DELETE_USER_LAB_PANEL: "/api/v2/Precision/LabPanel/DeleteUserLabPanel/",
    RESET_APPROVALS: "/api/v2/Precision/Report/PublishAllApprovals/",
    FINALIZE_CUSTOMER_LAB_PANEL: "/api/v2/Precision/LabPanel/FinalizeCustomerLabPanel/",
    APPROVE_CUSTOMER_LAB_PANEL: "/api/v2/Precision/LabPanel/ApproveCustomerLabPanel/",
    REJECT_CUSTOMER_LAB_PANEL: "/api/v2/Precision/LabPanel/RejectCustomerLabPanel/",
    RETRY_LAB_PANEL: "/api/v2/Precision/LabPanel/RetryLabPanel/",
    GET_INBODY_ACCOUNT: "/api/v2/Precision/User/GetInbodyAccount",
    SET_INBODY_ACCOUNT: "/api/v2/Precision/User/SetInbodyAccount",
    DISCONNECT_INBODY: "/api/v2/Precision/User/DisconnectInbodyAccount",
    GET_INBODY_DATETIMES: "/api/v2/Precision/Inbody/GetDateTimes/",
    GET_INBODY_DATA: "/api/v2/Precision/Inbody/GetData/",
    // History listings are paginated: `?page=&rows=&userid=`, returning
    // `{ count, totalCount, currentPage, sortOrder, sortDirection, data[] }`
    // sorted by DateCreated desc. Without `userid` they cover every client of
    // the logged-in company. The singular paths take the record id.
    GET_HISTORY_SERVICES: "/api/v2/precision/history/services",
    // Documented as the singular `history/service/{id}`, but dev answers 404
    // there for every id and serves the record at the plural path.
    GET_HISTORY_SERVICE: "/api/v2/precision/history/services/",
    GET_HISTORY_PRESCRIPTIONS: "/api/v2/precision/history/prescription",
    GET_HISTORY_PRESCRIPTION: "/api/v2/precision/history/prescription/",
    GET_HISTORY_INBODY: "/api/v2/precision/history/inbody",
    GET_HISTORY_LAB_PANELS: "/api/v2/precision/history/labpanels",
    GET_HISTORY_LAB_PANEL: "/api/v2/precision/history/labpanels/",
    // Returns the biomarkers of one InBody batch (an array, not a record).
    GET_HISTORY_INBODY_RECORD: "/api/v2/precision/history/inbody/",
  },
  NUTRITION: {
    SETTINGS_URL: "api/customer/questionnaire/completed",
    SUBMIT_BIOMETRIC_QUESTIONNAIRE: "api/customer/questionnaire/biometrics",
    SUBMIT_LIFESTYLE_QUESTIONNAIRE: "api/customer/questionnaire/lifestyle",
    FETCH_HOME_URL: "api/customer/health/home",
    INTEGRATIONS_STATUS_URL: "api/customer/health/providers/status",
    CUSTOMER_INGREDIENT: "api/customer/ingredients",
    CUSTOMER_QUESTIONNAIRE_NUTRITION: "api/customer/questionnaire/nutrition",
    CUSTOMER_PERSONAL_INFO: "api/customer/profile/biometrics",
    EDIT_CUSTOMER_PERSONAL_INFO: "api/customer/profile/biometrics/edit",
    FETCH_GRAPHS_PAGE_DATA: "api/customer/health/home/graphs",
    // Active nutrition plan (same paths as the mobile app). Both take
    // `?date=yyyy-MM-dd&original=false`; the weekly one returns the Monday-based
    // week that contains `date`.
    CUSTOMER_ACTIVE_PLAN_WEEKLY: "api/customer/plans/active",
    // Weekly workout plan (same paths as the mobile WorkoutTab). The week is
    // two calls, both `?date=<Monday>`: the planned activities and wearable
    // events per day, and the scheduled coached services to place on days.
    CUSTOMER_ACTIVITY_WEEKLY_OVERVIEW:
      "api/customer/health/activity/weekly/overview",
    CUSTOMER_SCHEDULED_SERVICES: "api/customer/scheduled-services",
    // Per-workout detail. V2 (exercise groups → exercises → sets) takes
    // `?date=` for date-specific alternatives; V1 is the legacy flat record.
    CUSTOMER_ACTIVITY_EXERCISE_GROUPS: (activityId: string) =>
      `api/customer/activities/${activityId}/exercise_groups/views`,
    CUSTOMER_ACTIVITY_DETAILS: (activityId: string) =>
      `api/customer/health/activity/${activityId}`,
    // Post-workout analysis of one recorded session (HR series, zones, fuel).
    CUSTOMER_ACTIVITY_EVENT_ANALYSIS: (eventId: string) =>
      `api/customer/health/activity/events/${eventId}`,
  },
  // PNOĒ Breath Data API. Use the documented `/api/v1/*` namespace: its scheme
  // (`ExternalMeasurementBearer`) is a Cognito ID token, which is exactly what
  // `user.token` is. The `/api/v1/platform/breathapi/*` namespace exists but is
  // undocumented and wants a first-party access token we never hold.
  BREATH: {
    // Catalogs, participant parameters and protocol parameters in one payload.
    CONFIGURATION: "/api/v1/configuration",
    // Listing needs the trailing slash; the per-measurement paths append the id
    // to the same prefix: `${MEASUREMENT}${id}${MEASUREMENT_PHASES}` etc.
    MEASUREMENTS: "/api/v1/measurements/",
    MEASUREMENT: "/api/v1/measurements/",
    MEASUREMENT_COMPLETE: "/complete",
    MEASUREMENT_INVALIDATE: "/invalidate",
    MEASUREMENT_PARTICIPANT: "/participant",
    MEASUREMENT_PROTOCOL: "/protocol",
    MEASUREMENT_PHASES: "/phases",
    MEASUREMENT_VO2_DATA: "/vo2-data",
    MEASUREMENT_VO2_EXPORT: "/vo2-data/export",
  },
};

export default ENDPOINTS;
